<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>复制广告(Adq)</span>
        <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
      </div>
      <div class="top">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input
              v-model.trim="query.source_sub_uc_id"
              placeholder="请输入来源广告账户id"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model.trim="query.source_sub_uc_name"
              placeholder="请输入来源广告账户名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model.trim="query.source_campaign_id"
              placeholder="请输入来源广告组id"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-button type="primary" @click="fetchAdqAdvertList">搜索</el-button>
          <el-button
            type="info"
            @click="resetTencentAdqAdverList"
          >重置</el-button>
          <el-button type="warning" @click="stopAD">停止广告复制</el-button>
        </el-row>
      </div>
      <div class="main">
        <el-table
          v-loading="loading"
          :data="adqAdvertList"
          style="width: 100%;border:1px"
          :row-key="getRowKeys"
        >
          <el-table-column prop="id" label="复制任务id" align="center" width="90" />
          <el-table-column
            prop="source_user_id"
            label="来源主账户id"
            align="center"
            width="130"
          />
          <el-table-column
            prop="source_sub_uc_id"
            label="来源子账户id"
            align="center"
            width="130"
          />
          <el-table-column
            prop="source_campaignFeedName"
            label="来源计划名称"
            align="center"
            width="130"
          />
          <el-table-column
            prop="target_sub_uc_id"
            label="目标子账户id"
            align="center"
            width="130"
          />
          <el-table-column
            prop="target_sub_uc_name"
            label="目标子账户名称"
            align="center"
            width="200"
          />
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            width="80"
          >
            <template scope="scope">
              {{
                scope.row.status == 1
                  ? '完成'
                  : scope.row.status == 2
                    ? '终止'
                    : '待处理'
              }}
            </template></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="80"
          />
          <el-table-column
            prop="copy_num"
            label="计划数量"
            align="center"
            width="80"
          />
          <el-table-column
            prop="success_num"
            label="成功数量"
            align="center"
            width="80"
          />

          <el-table-column
            prop="updated_at"
            label="更新时间"
            align="center"
            width="180"
          />
          <el-table-column prop="created_at" label="创建时间" align="center" width="200px" />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="linkskip(scope.row)"
              >
                任务执行记录
              </el-button>
            </template>
          </el-table-column>
          <CopyMpAdDialog ref="copyMpAdDialog" />
        </el-table>
        <el-dialog
          :title="'停止复制'"
          :visible.sync="dialogAccout"
          width="50%"
        >
          <dialogAccout ref="allocation" />
        </el-dialog>
        <PaginationRight
          :total="pageTotal"
          :page.sync="query.page"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { job_list } from '@/api/baiduAD'
import CopyMpAdDialog from '@/views/baiduAD/copyRecord/CopyAdqAdDialog/index.vue'
import dialogAccout from '@/views/baiduAD/copyRecord/components/dialogAccout.vue'
export default {
  name: 'CopyAdqAdvertManage',
  components: {
    CopyMpAdDialog,
    PaginationRight,
    dialogAccout
  },
  data() {
    return {
      loading: false,
      pageTotal: 0,
      query: {
        source_sub_uc_id: null,
        source_sub_uc_name: null,
        source_campaign_id: null,
        page: 1,
        page_size: 10
      },
      adqAdvertList: [],
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: null,
      dialogAccout: false
    }
  },
  created() {
    this.fetchAdqAdvertList()
  },
  methods: {
    stopAD() {
      this.dialogAccout = true
      this.$nextTick(() => {
        this.$refs.allocation.sendr()
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.fetchAdqAdvertList()
    },
    linkskip(row) {
      this.$refs.copyMpAdDialog.open(row, 1)
      // this.$router.push({ path: '/tencentAD/copyRecord/job-record', query: { row: row }})
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      job_list(this.query).then((res) => {
        this.adqAdvertList = res.data.list
        this.pageTotal = res.data.total
        this.loading = false
      })
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        source_adgroup_id: null, // 来源广告组id
        source_account_id: this.$route.query.account_id, // 来源广告账户id
        source_account_name: null, // 来源广告账户名称
        page: 1,
        page_size: 10
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    getRowKeys(row) {
      return row.adgroup_id
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
